package org.multipaz.doctypes.generated

/**
 * Generated strings for language: he
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_he = mapOf(
    "age_verification_attribute_older_than_years" to "מעל {age} שנים",
    "age_verification_description_older_than_years" to "ציון אם בעל הרישיון הוא בן {age} או מבוגר יותר",
    "age_verification_request_age_over_18" to "גיל מעל 18",
    "age_verification_request_age_over_18_zkp" to "גיל מעל 18 (ZKP)",
    "age_verification_request_age_over_21" to "גיל מעל 21",
    "age_verification_request_age_over_21_zkp" to "גיל מעל 21 (ZKP)",
    "age_verification_request_all_data_elements" to "כל רכיבי הנתונים",
    "document_display_name_age_verification" to "אימות גיל",
    "document_display_name_driving_license" to "רישיון נהיגה",
    "document_display_name_eu_personal_id" to "תעודה מזהה אישית",
    "document_display_name_google_wallet_id_pass" to "כרטיס זיהוי בארנק Google",
    "document_display_name_photo_id" to "תעודת זיהוי",
    "document_display_name_vaccination_document" to "מסמך חיסון",
    "document_display_name_vehicle_registration" to "רישוי רכב",
    "driving_license_attribute_aamva_version_number" to "מספר גרסת AAMVA",
    "driving_license_attribute_administrative_number" to "מספר מנהלי",
    "driving_license_attribute_age_in_years" to "גיל בשנים",
    "driving_license_attribute_alias_family_name" to "שם משפחה חלופי / ידוע גם כ",
    "driving_license_attribute_alias_given_name" to "שם פרטי חלופי / ידוע גם כ",
    "driving_license_attribute_alias_suffix" to "סיומת שם חלופית / ידועה גם כ",
    "driving_license_attribute_audit_information" to "מידע ביקורת",
    "driving_license_attribute_biometric_template_face" to "תבנית ביומטרית פנים",
    "driving_license_attribute_biometric_template_fingerprint" to "תבנית ביומטרית טביעת אצבע",
    "driving_license_attribute_biometric_template_iris" to "תבנית ביומטרית קשתית",
    "driving_license_attribute_biometric_template_signature_sign" to "תבנית ביומטרית חתימה",
    "driving_license_attribute_compliance_type" to "סוג תאימות",
    "driving_license_attribute_date_of_birth" to "תאריך לידה",
    "driving_license_attribute_date_of_expiry" to "תאריך תפוגה",
    "driving_license_attribute_date_of_issue" to "תאריך הנפקה",
    "driving_license_attribute_domestic_driving_privileges" to "זכויות נהיגה מקומיות",
    "driving_license_attribute_driving_privileges" to "היתרי נהיגה",
    "driving_license_attribute_edl_indicator" to "מחוון EDL",
    "driving_license_attribute_eye_color" to "צבע עיניים",
    "driving_license_attribute_family_name" to "שם משפחה",
    "driving_license_attribute_family_name_national_characters" to "שם משפחה בתווים לאומיים",
    "driving_license_attribute_family_name_truncation" to "קיצור שם משפחה",
    "driving_license_attribute_given_name_national_characters" to "שם פרטי בתווים לאומיים",
    "driving_license_attribute_given_name_truncation" to "קיצור שם פרטי",
    "driving_license_attribute_given_names" to "שמות פרטיים",
    "driving_license_attribute_hair_color" to "צבע שיער",
    "driving_license_attribute_hazmat_endorsement_expiration_date" to "תאריך תפוגה של אישור HAZMAT",
    "driving_license_attribute_height" to "גובה",
    "driving_license_attribute_issuing_authority" to "רשות מנפיקה",
    "driving_license_attribute_issuing_country" to "מדינת הנפקה",
    "driving_license_attribute_issuing_jurisdiction" to "רשות מנפיקה",
    "driving_license_attribute_license_number" to "מספר רישיון",
    "driving_license_attribute_limited_duration_document_indicator" to "מחוון מסמך מוגבל בזמן",
    "driving_license_attribute_name_suffix" to "סיומת שם",
    "driving_license_attribute_nationality" to "לאום",
    "driving_license_attribute_older_than_13" to "מעל 13 שנים",
    "driving_license_attribute_older_than_16" to "מעל 16 שנים",
    "driving_license_attribute_older_than_18" to "מעל 18 שנים",
    "driving_license_attribute_older_than_21" to "מעל 21 שנים",
    "driving_license_attribute_older_than_25" to "מעל 25 שנים",
    "driving_license_attribute_older_than_60" to "מעל 60 שנים",
    "driving_license_attribute_older_than_62" to "מעל 62 שנים",
    "driving_license_attribute_older_than_65" to "מעל גיל 65",
    "driving_license_attribute_older_than_68" to "מעל גיל 68",
    "driving_license_attribute_organ_donor" to "תורם איברים",
    "driving_license_attribute_photo_of_holder" to "תמונת המחזיק",
    "driving_license_attribute_place_of_birth" to "מקום לידה",
    "driving_license_attribute_portrait_image_timestamp" to "חותמת זמן תמונת דיוקן",
    "driving_license_attribute_race_ethnicity" to "גזע / מוצא אתני",
    "driving_license_attribute_resident_address" to "כתובת מגורים",
    "driving_license_attribute_resident_city" to "עיר מגורים",
    "driving_license_attribute_resident_country" to "מדינת מגורים",
    "driving_license_attribute_resident_county" to "מחוז מגורים",
    "driving_license_attribute_resident_postal_code" to "מיקוד מגורים",
    "driving_license_attribute_resident_state" to "מחוז מגורים",
    "driving_license_attribute_sex" to "מין",
    "driving_license_attribute_signature_usual_mark" to "חתימה / סימן רגיל",
    "driving_license_attribute_un_distinguishing_sign" to "סימן היכר של האו\"ם",
    "driving_license_attribute_veteran" to "ותיק",
    "driving_license_attribute_weight" to "משקל",
    "driving_license_attribute_weight_range" to "טווח משקל",
    "driving_license_attribute_year_of_birth" to "שנת לידה",
    "driving_license_description_aamva_version_number" to "מספר המזהה את גרסת קבוצת רכיבי הנתונים של AAMVA mDL",
    "driving_license_description_administrative_number" to "מספר ביקורת מנהלי שהוקצה על ידי הרשות המנפיקה.",
    "driving_license_description_age_in_years" to "גילו של בעל הרישיון",
    "driving_license_description_alias_family_name" to "שם משפחה נוסף שבו ידוע בעל התעודה.",
    "driving_license_description_alias_given_name" to "שם פרטי נוסף שבו ידוע בעל התעודה.",
    "driving_license_description_alias_suffix" to "סיומת נוספת שבה ידוע בעל התעודה.",
    "driving_license_description_audit_information" to "מחרוזת של אותיות ו/או מספרים המזהה מתי, היכן ועל ידי מי סופק האישור לראשונה.",
    "driving_license_description_biometric_template_face" to "מידע ביומטרי פנים של מחזיק ה-mDL",
    "driving_license_description_biometric_template_fingerprint" to "טביעת אצבע של מחזיק ה-mDL",
    "driving_license_description_biometric_template_iris" to "קשתית של מחזיק ה-mDL",
    "driving_license_description_biometric_template_signature_sign" to "חתימה של מחזיק ה-mDL",
    "driving_license_description_compliance_type" to "שדה חובה של ה־DHS המציין תאימות.",
    "driving_license_description_date_of_birth" to "יום, חודש ושנה בהם נולד בעל ה-mDL. אם לא ידוע, תאריך לידה משוער",
    "driving_license_description_date_of_expiry" to "תאריך תפוגת ה-mDL",
    "driving_license_description_date_of_issue" to "תאריך הנפקת ה-mDL",
    "driving_license_description_domestic_driving_privileges" to "סוגי כלי הרכב שבעל הרישיון מורשה לנהוג בהם",
    "driving_license_description_driving_privileges" to "הרשאות הנהיגה של בעל הרישיון.",
    "driving_license_description_edl_indicator" to "קיים אם התעודה היא EDL.",
    "driving_license_description_eye_color" to "צבע עיני בעל הרישיון.",
    "driving_license_description_family_name" to "שם משפחה, או מזהה עיקרי, של בעל ה-mDL.",
    "driving_license_description_family_name_national_characters" to "שם המשפחה של בעל ה-mDL",
    "driving_license_description_family_name_truncation" to "קוד המציין אם השדה קוצץ.",
    "driving_license_description_given_name_national_characters" to "השם הפרטי של בעל ה-mDL",
    "driving_license_description_given_name_truncation" to "קוד המציין אם השם הפרטי או שמות הביניים קוצצו.",
    "driving_license_description_given_names" to "שם פרטי (או שמות פרטיים), שמות נוספים, או מזהה משני, של בעל ה-mDL",
    "driving_license_description_hair_color" to "צבע שיערו של בעל הרישיון",
    "driving_license_description_hazmat_endorsement_expiration_date" to "התאריך שבו אישור החומרים המסוכנים שהוענק על ידי המסמך אינו תקף עוד.",
    "driving_license_description_height" to "גובה בעל הרישיון בסנטימטרים.",
    "driving_license_description_issuing_authority" to "שם הרשות המנפיקה.",
    "driving_license_description_issuing_country" to "קוד מדינה בן שתי אותיות (Alpha-2), כהגדרתו ב-ISO 3166-1, של המדינה או הטריטוריה של הרשות המנפיקה",
    "driving_license_description_issuing_jurisdiction" to "קוד חלוקה מנהלית של רשות ההנפקה של ה-mDL.",
    "driving_license_description_license_number" to "המספר שהוקצה או חושב על ידי הרשות המנפיקה.",
    "driving_license_description_limited_duration_document_indicator" to "שדה חובה של ה־DHS המציין אם לבעל התעודה יש מעמד חוקי זמני. 1: מעמד חוקי זמני.",
    "driving_license_description_name_suffix" to "סיומת השם של האדם שלו הונפק רישיון הנהיגה או תעודת הזיהוי.",
    "driving_license_description_nationality" to "אזרחותו של בעל ה-mDL.",
    "driving_license_description_older_than_13" to "ציון אם בעל הרישיון הוא בן 13 או מבוגר יותר",
    "driving_license_description_older_than_16" to "ציון אם בעל הרישיון הוא בן 16 או מבוגר יותר",
    "driving_license_description_older_than_18" to "ציון אם בעל הרישיון הוא בן 18 או מבוגר יותר",
    "driving_license_description_older_than_21" to "ציון אם בעל הרישיון הוא בן 21 או מבוגר יותר",
    "driving_license_description_older_than_25" to "אינדיקציה האם בעל ה-mDL הוא בן 25 ומעלה.",
    "driving_license_description_older_than_60" to "אינדיקציה האם בעל ה-mDL הוא בן 60 ומעלה.",
    "driving_license_description_older_than_62" to "אינדיקציה האם בעל ה-mDL הוא בן 62 ומעלה.",
    "driving_license_description_older_than_65" to "אינדיקציה האם בעל ה-mDL הוא בן 65 ומעלה.",
    "driving_license_description_older_than_68" to "אינדיקציה האם בעל ה-mDL הוא בן 68 ומעלה.",
    "driving_license_description_organ_donor" to "מחוון המציין אם בעל התעודה הוא תורם איברים.",
    "driving_license_description_photo_of_holder" to "תמונת הדיוקן של בעל הרישיון.",
    "driving_license_description_place_of_birth" to "מדינה ועירייה או מדינה/מחוז שבהם נולד בעל הרישיון",
    "driving_license_description_portrait_image_timestamp" to "תאריך צילום תמונת הפרופיל",
    "driving_license_description_race_ethnicity" to "קודים של גזע או מוצא אתני של בעל הכרטיס.",
    "driving_license_description_resident_address" to "המקום שבו בעל הרישיון מתגורר ו/או ניתן ליצור איתו קשר (רחוב/מספר בית, עירייה וכד')",
    "driving_license_description_resident_city" to "העיר שבה מתגורר בעל ה-mDL.",
    "driving_license_description_resident_country" to "המדינה שבה מתגורר בעל ה-mDL",
    "driving_license_description_resident_county" to "קוד המחוז בן 3 הספרות של המחוז שבו מתגורר בעל ה־mDL.",
    "driving_license_description_resident_postal_code" to "המיקוד של בעל ה-mDL.",
    "driving_license_description_resident_state" to "המדינה/פרובינציה/מחוז שבהם מתגורר בעל ה-mDL.",
    "driving_license_description_sex" to "מין בעל הרישיון.",
    "driving_license_description_signature_usual_mark" to "תמונת החתימה או הסימן הרגיל של בעל ה-mDL,",
    "driving_license_description_un_distinguishing_sign" to "סימן ההיכר של המדינה המנפיקה.",
    "driving_license_description_veteran" to "מחוון המציין אם בעל התעודה הוא ותיק.",
    "driving_license_description_weight" to "משקל בעל הרישיון בקילוגרמים.",
    "driving_license_description_weight_range" to "מציין את טווח המשקל המשוער של בעל הכרטיס.",
    "driving_license_description_year_of_birth" to "השנה שבה נולד בעל הרישיון",
    "driving_license_request_age_over_18" to "גיל מעל 18",
    "driving_license_request_age_over_18_and_portrait" to "גיל מעל 18 + תמונה",
    "driving_license_request_age_over_18_and_portrait_equivalence" to "גיל 18+ + שקילות דיוקן",
    "driving_license_request_age_over_18_and_portrait_or_portrait_equivalence" to "גיל 18+ + (דיוקן או שקילות דיוקן)",
    "driving_license_request_age_over_18_zkp" to "גיל מעל 18 (ZKP)",
    "driving_license_request_age_over_21" to "גיל מעל 21",
    "driving_license_request_age_over_21_and_portrait" to "גיל מעל 21 + תמונה",
    "driving_license_request_age_over_21_zkp" to "גיל מעל 21 (ZKP)",
    "driving_license_request_all_data_elements" to "כל רכיבי הנתונים",
    "driving_license_request_mandatory_data_elements" to "רכיבי נתונים חובה",
    "driving_license_request_name_and_address_all_stored" to "שם וכתובת (מאוחסנים במלואם)",
    "driving_license_request_name_and_address_partially_stored" to "שם וכתובת (מאוחסנים חלקית)",
    "driving_license_request_us_transportation" to "תחבורה ארה\"ב",
    "eu_personal_id_attribute_address" to "כתובת",
    "eu_personal_id_attribute_age_in_years" to "גיל בשנים",
    "eu_personal_id_attribute_city_of_birth" to "עיר לידה",
    "eu_personal_id_attribute_country_of_birth" to "ארץ לידה",
    "eu_personal_id_attribute_date_of_birth" to "תאריך לידה",
    "eu_personal_id_attribute_date_of_expiry" to "תאריך תפוגה",
    "eu_personal_id_attribute_date_of_issue" to "תאריך הנפקה",
    "eu_personal_id_attribute_document_number" to "מספר מסמך",
    "eu_personal_id_attribute_email_address_of_holder" to "כתובת אימייל של בעל המסמך",
    "eu_personal_id_attribute_family_name" to "שם משפחה",
    "eu_personal_id_attribute_family_name_at_birth" to "שם משפחה בלידה",
    "eu_personal_id_attribute_first_name_at_birth" to "שם פרטי בלידה",
    "eu_personal_id_attribute_given_names" to "שמות פרטיים",
    "eu_personal_id_attribute_issuing_authority" to "רשות מנפיקה",
    "eu_personal_id_attribute_issuing_country" to "מדינה מנפיקה",
    "eu_personal_id_attribute_issuing_jurisdiction" to "תחום שיפוט מנפיק",
    "eu_personal_id_attribute_mobile_phone_of_holder" to "טלפון נייד של המחזיק",
    "eu_personal_id_attribute_nationality" to "אזרחות",
    "eu_personal_id_attribute_older_than_18" to "מבוגר מ-18",
    "eu_personal_id_attribute_older_than_21" to "מבוגר מ-21",
    "eu_personal_id_attribute_older_than_age_attestations" to "אישורי גיל (מעל גיל)",
    "eu_personal_id_attribute_personal_administrative_number" to "מספר זיהוי אישי",
    "eu_personal_id_attribute_photo_of_holder" to "תמונת בעל המסמך",
    "eu_personal_id_attribute_place_of_birth" to "מקום לידה",
    "eu_personal_id_attribute_resident_address" to "כתובת מגורים",
    "eu_personal_id_attribute_resident_city" to "עיר מגורים",
    "eu_personal_id_attribute_resident_country" to "מדינת מגורים",
    "eu_personal_id_attribute_resident_house_number" to "מספר בית מגורים",
    "eu_personal_id_attribute_resident_postal_code" to "מיקוד מגורים",
    "eu_personal_id_attribute_resident_state" to "מחוז מגורים",
    "eu_personal_id_attribute_resident_street" to "רחוב מגורים",
    "eu_personal_id_attribute_sex" to "מין",
    "eu_personal_id_attribute_state_of_birth" to "מדינת לידה",
    "eu_personal_id_attribute_year_of_birth" to "שנת לידה",
    "eu_personal_id_description_address" to "כתובת",
    "eu_personal_id_description_age_in_years" to "גילו של מחזיק ה-PID בשנים",
    "eu_personal_id_description_city_of_birth" to "הרשות המקומית, העיר, העיירה או הכפר שבהם נולד משתמש ה-PID",
    "eu_personal_id_description_country_of_birth" to "המדינה שבה נולד משתמש ה-PID, כקוד מדינה בן 2 אותיות כפי שמפורט ב-ISO 3166-1",
    "eu_personal_id_description_date_of_birth" to "יום, חודש ושנה בהם נולד מחזיק ה-PID. אם לא ידוע, תאריך לידה משוער.",
    "eu_personal_id_description_date_of_expiry" to "תאריך (ואולי שעה) תפוגת ה-PID.",
    "eu_personal_id_description_date_of_issue" to "תאריך (ואולי שעה) הנפקת ה-PID.",
    "eu_personal_id_description_document_number" to "מספר ל-PID, שהוקצה על ידי ספק ה-PID.",
    "eu_personal_id_description_email_address_of_holder" to "כתובת דואר אלקטרוני של המשתמש שאליו מתייחסים נתוני הזיהוי האישי, בהתאם ל-[RFC 5322].",
    "eu_personal_id_description_family_name" to "שם(שמות) משפחה נוכחי(ים), או מזהה ראשי של מחזיק ה-PID",
    "eu_personal_id_description_family_name_at_birth" to "שם משפחה, או מזהה ראשי של בעל ה-PID בלידה",
    "eu_personal_id_description_first_name_at_birth" to "שם פרטי, שם אחר, או מזהה משני של בעל ה-PID בלידה",
    "eu_personal_id_description_given_names" to "שם(שמות) פרטי(ים) נוכחי(ים), שם(שמות) נוסף(פים), או מזהה משני של מחזיק ה-PID",
    "eu_personal_id_description_issuing_authority" to "שם הרשות המנהלית שהנפיקה את עותק ה-PID הזה, או קוד המדינה בפורמט ISO 3166 Alpha-2 של המדינה החברה הרלוונטית אם אין רשות נפרדת המוסמכת להנפיק PIDs.",
    "eu_personal_id_description_issuing_country" to "קוד מדינה Alpha-2, כהגדרתו ב-ISO 3166-1, של מדינת או טריטוריית הרשות המנפיקה.",
    "eu_personal_id_description_issuing_jurisdiction" to "קוד חלוקה מנהלית של המדינה של תחום השיפוט שהנפיק את ה-PID, כהגדרתו ב-ISO 3166-2:2020, סעיף 8. החלק הראשון של הקוד יציין את אותו ערך כמו של issuing_country.",
    "eu_personal_id_description_mobile_phone_of_holder" to "מספר טלפון נייד של המשתמש שאליו מתייחסים נתוני הזיהוי האישי, ומתחיל בסימן '+ כתחילית קוד בינלאומי וקידומת המדינה, ואחריו מספרים בלבד.",
    "eu_personal_id_description_nationality" to "קוד מדינה אלפא-2 כפי שמפורט ב-ISO 3166-1, המייצג את הלאום של משתמש מזהה אישי.",
    "eu_personal_id_description_older_than_18" to "מעל גיל 18?",
    "eu_personal_id_description_older_than_21" to "מעל גיל 21?",
    "eu_personal_id_description_older_than_age_attestations" to "אישורי גיל (מעל גיל)",
    "eu_personal_id_description_personal_administrative_number" to "מספר שהוקצה על ידי ספק ה-PID לצורך בקרת ביקורת או מטרות אחרות.",
    "eu_personal_id_description_photo_of_holder" to "שחזור תמונת הדיוקן של בעל ה-PID.",
    "eu_personal_id_description_place_of_birth" to "מדינה, רשות מקומית או מחוז/פרובינציה שבהם נולד בעל ה-PID",
    "eu_personal_id_description_resident_address" to "הכתובת המלאה של מקום המגורים הנוכחי של בעל מזהה אישי ו/או שבו ניתן ליצור איתו קשר (רחוב/מספר בית, רשות מקומית וכו').",
    "eu_personal_id_description_resident_city" to "העיר שבה בעל מזהה אישי מתגורר כעת.",
    "eu_personal_id_description_resident_country" to "המדינה שבה משתמש מזהה אישי מתגורר כעת, כקוד מדינה אלפא-2 כפי שמפורט ב-ISO 3166-1.",
    "eu_personal_id_description_resident_house_number" to "מספר הבית שבו משתמש מזהה אישי מתגורר כעת, כולל כל קידומת או סיומת.",
    "eu_personal_id_description_resident_postal_code" to "המיקוד של המקום שבו בעל מזהה אישי מתגורר כעת.",
    "eu_personal_id_description_resident_state" to "המדינה, הפרובינציה, המחוז או האזור המקומי שבו משתמש מזהה אישי מתגורר כעת.",
    "eu_personal_id_description_resident_street" to "שם הרחוב שבו משתמש מזהה אישי מתגורר כעת.",
    "eu_personal_id_description_sex" to "מין בעל מזהה אישי",
    "eu_personal_id_description_state_of_birth" to "מחוז, פרובינציה, נפה או אזור מקומי שבו נולד משתמש ה-PID",
    "eu_personal_id_description_year_of_birth" to "השנה שבה נולד בעל ה-PID",
    "eu_personal_id_request_age_over_18" to "גיל מעל 18",
    "eu_personal_id_request_age_over_18_and_portrait" to "גיל מעל 18 + תמונה",
    "eu_personal_id_request_age_over_18_and_portrait_equivalence" to "גיל 18+ + שקילות דיוקן",
    "eu_personal_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "גיל 18+ + (דיוקן או שקילות דיוקן)",
    "eu_personal_id_request_age_over_18_zkp" to "גיל מעל 18 (ZKP)",
    "eu_personal_id_request_all_data_elements" to "כל רכיבי המידע",
    "eu_personal_id_request_mandatory_data_elements" to "רכיבי מידע חובה",
    "eu_personal_id_request_name_and_portrait" to "שם + דיוקן",
    "eu_personal_id_request_name_and_portrait_equivalence" to "שם + שקילות דיוקן",
    "eu_personal_id_request_name_and_portrait_or_portrait_equivalence" to "שם + (דיוקן או שקילות דיוקן)",
    "id_pass_request_age_over_18" to "גיל מעל 18",
    "id_pass_request_age_over_18_and_portrait" to "גיל מעל 18 + דיוקן",
    "id_pass_request_age_over_18_and_portrait_equivalence" to "גיל 18+ + שקילות דיוקן",
    "id_pass_request_age_over_18_and_portrait_or_portrait_equivalence" to "גיל 18+ (פורטרט או שווה ערך לפורטרט)",
    "id_pass_request_age_over_18_zkp" to "גיל מעל 18 (ZKP)",
    "id_pass_request_age_over_21" to "גיל מעל 21",
    "id_pass_request_age_over_21_and_portrait" to "גיל מעל 21 + דיוקן",
    "id_pass_request_age_over_21_zkp" to "גיל מעל 21 (ZKP)",
    "id_pass_request_all_data_elements" to "כל רכיבי המידע",
    "id_pass_request_mandatory_data_elements" to "רכיבי מידע חובה",
    "multi_request_age_over_18_mdl_or_pid" to "גיל מעל 18 באמצעות mDL או PID ועסקה",
    "multi_request_mdl_and_photoid" to "mDL ו-PhotoID",
    "multi_request_mdl_or_photoid" to "mDL או PhotoID",
    "multi_request_payment_and_age_over_18" to "תשלום וגיל מעל 18",
    "photo_id_attribute_administrative_number" to "מספר מנהלי",
    "photo_id_attribute_age_in_years" to "גיל בשנים",
    "photo_id_attribute_birth_city" to "עיר לידה",
    "photo_id_attribute_birth_country" to "ארץ לידה",
    "photo_id_attribute_birth_state" to "מדינת לידה",
    "photo_id_attribute_date_of_birth" to "תאריך לידה",
    "photo_id_attribute_date_of_expiry" to "תאריך תפוגה",
    "photo_id_attribute_date_of_issue" to "תאריך הנפקה",
    "photo_id_attribute_document_number" to "מספר מסמך",
    "photo_id_attribute_dtc_vc_version" to "גרסת DTC-VC",
    "photo_id_attribute_emrtd_dg1" to "eMRTD DG1",
    "photo_id_attribute_emrtd_dg10" to "eMRTD DG10",
    "photo_id_attribute_emrtd_dg11" to "eMRTD DG11",
    "photo_id_attribute_emrtd_dg12" to "eMRTD DG12",
    "photo_id_attribute_emrtd_dg13" to "eMRTD DG13",
    "photo_id_attribute_emrtd_dg14" to "eMRTD DG14",
    "photo_id_attribute_emrtd_dg15" to "eMRTD DG15",
    "photo_id_attribute_emrtd_dg16" to "eMRTD DG16",
    "photo_id_attribute_emrtd_dg2" to "eMRTD DG2",
    "photo_id_attribute_emrtd_dg3" to "eMRTD DG3",
    "photo_id_attribute_emrtd_dg4" to "eMRTD DG4",
    "photo_id_attribute_emrtd_dg5" to "eMRTD DG5",
    "photo_id_attribute_emrtd_dg6" to "eMRTD DG6",
    "photo_id_attribute_emrtd_dg7" to "eMRTD DG7",
    "photo_id_attribute_emrtd_dg8" to "eMRTD DG8",
    "photo_id_attribute_emrtd_dg9" to "eMRTD DG9",
    "photo_id_attribute_emrtd_sod" to "SOD של eMRTD",
    "photo_id_attribute_family_name" to "שם משפחה",
    "photo_id_attribute_family_name_latin1" to "שם משפחה",
    "photo_id_attribute_family_name_viz" to "שם משפחה (VIZ)",
    "photo_id_attribute_given_name_viz" to "שם פרטי (VIZ)",
    "photo_id_attribute_given_names" to "שמות פרטיים",
    "photo_id_attribute_given_names_latin1" to "שמות פרטיים",
    "photo_id_attribute_issuing_authority" to "רשות מנפיקה",
    "photo_id_attribute_issuing_country" to "מדינה מנפיקה",
    "photo_id_attribute_issuing_subdivision" to "יחידת הנפקה",
    "photo_id_attribute_name_at_birth" to "שם בלידה",
    "photo_id_attribute_nationality" to "אזרחות",
    "photo_id_attribute_person_id" to "מספר זיהוי",
    "photo_id_attribute_photo_of_holder" to "תמונת המחזיק",
    "photo_id_attribute_place_of_birth" to "מקום לידה",
    "photo_id_attribute_portrait_capture_date" to "תאריך צילום דיוקן",
    "photo_id_attribute_resident_address" to "כתובת מגורים",
    "photo_id_attribute_resident_city" to "עיר מגורים",
    "photo_id_attribute_resident_city_latin1" to "עיר מגורים",
    "photo_id_attribute_resident_country" to "ארץ מגורים",
    "photo_id_attribute_resident_house_number" to "מספר בית מגורים",
    "photo_id_attribute_resident_postal_code" to "מיקוד מגורים",
    "photo_id_attribute_resident_state" to "מדינת מגורים",
    "photo_id_attribute_resident_street" to "רחוב מגורים",
    "photo_id_attribute_sex" to "מין",
    "photo_id_attribute_travel_document_mrz" to "MRZ של מסמך נסיעה",
    "photo_id_attribute_travel_document_number" to "מספר מסמך נסיעה",
    "photo_id_attribute_travel_document_type" to "סוג מסמך נסיעה",
    "photo_id_attribute_year_of_birth" to "שנת לידה",
    "photo_id_description_administrative_number" to "מספר שהוקצה על ידי מנפיק תעודת הזהות המצולמת לבקרת ביקורת או מטרות אחרות",
    "photo_id_description_age_in_years" to "גיל בעל המסמך.",
    "photo_id_description_birth_city" to "העירייה, העיר, העיירה או הכפר שבהם נולד בעל תעודת הזהות המצולמת",
    "photo_id_description_birth_country" to "המדינה שבה נולד מחזיק תעודת הזהות עם תמונה, כקוד מדינה אלפא-2 כפי שמפורט ב-ISO 3166-1",
    "photo_id_description_birth_state" to "המדינה, המחוז, הנפה או האזור המקומי שבהם נולד מחזיק תעודת הזהות עם תמונה",
    "photo_id_description_date_of_birth" to "יום, חודש ושנה שבהם נולד בעל המסמך. אם לא ידוע, תאריך לידה משוער",
    "photo_id_description_date_of_expiry" to "תאריך תפוגת המסמך",
    "photo_id_description_date_of_issue" to "תאריך הנפקת המסמך",
    "photo_id_description_document_number" to "המספר שהוקצה או חושב על ידי הרשות המנפיקה",
    "photo_id_description_dtc_vc_version" to "גרסת הגדרת DTC-VC",
    "photo_id_description_emrtd_dg1" to "קבוצת נתונים 1: נתונים ביוגרפיים (נתונים המוקלטים ב-MRZ) C",
    "photo_id_description_emrtd_dg10" to "קבוצת נתונים 10: מאפייני חומר",
    "photo_id_description_emrtd_dg11" to "קבוצת נתונים 11: פרט(ים) אישי(ים) נוסף(ים)",
    "photo_id_description_emrtd_dg12" to "קבוצת נתונים 12: פרט(ים) נוסף(ים) למסמך",
    "photo_id_description_emrtd_dg13" to "קבוצת נתונים 13: פרט(ים) אופציונלי(ים)",
    "photo_id_description_emrtd_dg14" to "קבוצת נתונים 14: אפשרויות אבטחה",
    "photo_id_description_emrtd_dg15" to "קבוצת נתונים 15: מידע מפתח ציבורי לאימות פעיל",
    "photo_id_description_emrtd_dg16" to "קבוצת נתונים 16: אדם/אנשים ליצירת קשר",
    "photo_id_description_emrtd_dg2" to "קבוצת נתונים 2: דיוקן ייחוס (פנים מקודדים)",
    "photo_id_description_emrtd_dg3" to "קבוצת נתונים 3: אצבעות מקודדות",
    "photo_id_description_emrtd_dg4" to "קבוצת נתונים 4: עין/עיניים מקודדות",
    "photo_id_description_emrtd_dg5" to "קבוצת נתונים 5: דיוקן מוצג",
    "photo_id_description_emrtd_dg6" to "קבוצת נתונים 6: שמורה לשימוש עתידי",
    "photo_id_description_emrtd_dg7" to "קבוצת נתונים 7: חתימה מוצגת או סימן מקובל",
    "photo_id_description_emrtd_dg8" to "קבוצת נתונים 8: מאפייני נתונים",
    "photo_id_description_emrtd_dg9" to "קבוצת נתונים 9: מאפייני מבנה",
    "photo_id_description_emrtd_sod" to "נתונים בינאריים של אובייקט אבטחת מסמך eMRTD",
    "photo_id_description_family_name" to "שם משפחה, או מזהה ראשי, של בעל המסמך",
    "photo_id_description_family_name_latin1" to "שם משפחה, או מזהה ראשי, של מחזיק המסמך",
    "photo_id_description_family_name_viz" to "שם משפחה כהגדרתו ל-VIZ (אזור בדיקה ויזואלית) בתקן ICAO 9303",
    "photo_id_description_given_name_viz" to "שם פרטי כהגדרתו ל-VIZ (אזור בדיקה ויזואלית) בתקן ICAO 9303",
    "photo_id_description_given_names" to "שם/שמות פרטיים, שמות נוספים, או מזהה משני, של בעל המסמך",
    "photo_id_description_given_names_latin1" to "שם/שמות פרטיים, שמות אחרים, או מזהה משני, של מחזיק המסמך",
    "photo_id_description_issuing_authority" to "שם הרשות המנפיקה",
    "photo_id_description_issuing_country" to "קוד מדינה (אלפא-2), כפי שהוגדר ב-ISO 3166-1, של מדינת או טריטוריית הרשות המנפיקה.",
    "photo_id_description_issuing_subdivision" to "קוד תת-חלוקה כהגדרתו ב-ISO 3166-2, שהנפיק את מסמך ה-eID הנייד או שבו נמצאת הרשות המנפיקה",
    "photo_id_description_name_at_birth" to "השם/שמות של בעל המסמך מלידתו.",
    "photo_id_description_nationality" to "אזרחותו של מחזיק המסמך",
    "photo_id_description_person_id" to "מזהה אדם של מחזיק תעודת הזהות עם תמונה",
    "photo_id_description_photo_of_holder" to "שעתוק של תמונת הפורטרט של בעל המסמך",
    "photo_id_description_place_of_birth" to "מדינה ורשות מקומית או מחוז/מדינה שבהם נולד בעל המסמך.",
    "photo_id_description_portrait_capture_date" to "תאריך צילום התמונה.",
    "photo_id_description_resident_address" to "המקום שבו מתגורר בעל המסמך ו/או שבו ניתן ליצור עמו קשר (רחוב/מספר בית, רשות מקומית וכו').",
    "photo_id_description_resident_city" to "העיר/רשות המקומית (או שווה ערך) שבה מתגורר בעל המסמך.",
    "photo_id_description_resident_city_latin1" to "העיר/רשות מקומית (או שווה ערך) שבה המחזיק מתגורר",
    "photo_id_description_resident_country" to "המדינה שבה מתגורר בעל המסמך.",
    "photo_id_description_resident_house_number" to "מספר הבית שבו מתגורר כיום בעל תעודת הזהות המצולמת, כולל כל קידומת או סיומת",
    "photo_id_description_resident_postal_code" to "המיקוד של בעל המסמך.",
    "photo_id_description_resident_state" to "המדינה/פרובינציה/מחוז שבהם מתגורר בעל תעודת הזהות המצולמת",
    "photo_id_description_resident_street" to "שם הרחוב שבו מתגורר כיום בעל תעודת הזהות המצולמת",
    "photo_id_description_sex" to "מין מחזיק המסמך",
    "photo_id_description_travel_document_mrz" to "אזור קריא במכונה כטקסט המודפס על המסמך הפיזי",
    "photo_id_description_travel_document_number" to "מספר מסמך הנסיעה שאליו מקושרת תעודת הזהות המצולמת (אם מקושרת למסמך נסיעה או נגזרת ממנו)",
    "photo_id_description_travel_document_type" to "מזהה סוג מסמך המקור, (אם מקושר למסמך נסיעה או נגזר ממנו)",
    "photo_id_description_year_of_birth" to "שנת לידתו של בעל המסמך.",
    "photo_id_request_age_over_18" to "גיל מעל 18",
    "photo_id_request_age_over_18_and_portrait" to "גיל מעל 18 + פורטרט",
    "photo_id_request_age_over_18_and_portrait_equivalence" to "גיל 18+ + שקילות דיוקן",
    "photo_id_request_age_over_18_and_portrait_or_portrait_equivalence" to "גיל 18+ + (דיוקן או שקילות דיוקן)",
    "photo_id_request_age_over_18_zkp" to "גיל מעל 18 (ZKP)",
    "photo_id_request_all_data_elements" to "כל רכיבי הנתונים",
    "photo_id_request_mandatory_data_elements" to "רכיבי נתונים חובה",
    "vaccination_attribute_birth_day" to "יום לידה",
    "vaccination_attribute_birth_month" to "חודש לידה",
    "vaccination_attribute_birth_year" to "שנת לידה",
    "vaccination_attribute_covid19_first_vaccination" to "חיסון ראשון RA01",
    "vaccination_attribute_covid19_second_vaccination" to "חיסון שני RA01",
    "vaccination_attribute_covid19_test" to "אירוע בדיקה לקורונה",
    "vaccination_attribute_covid19_vaccinated" to "חיסון נגד COVID-19",
    "vaccination_attribute_date_of_birth" to "תאריך לידה",
    "vaccination_attribute_facial_image" to "תמונת פנים",
    "vaccination_attribute_family_name" to "שם משפחה",
    "vaccination_attribute_family_name_initial" to "אות ראשונה של שם משפחה",
    "vaccination_attribute_given_name" to "שם פרטי",
    "vaccination_attribute_given_name_initial" to "אות ראשונה של שם פרטי",
    "vaccination_attribute_id_with_drivers_license_number" to "תעודה מזהה עם מספר רישיון נהיגה",
    "vaccination_attribute_id_with_passport_number" to "תעודה מזהה עם מספר דרכון",
    "vaccination_attribute_safe_entry_leisure" to "אינדיקציה לכניסה בטוחה",
    "vaccination_attribute_sex" to "מין",
    "vaccination_attribute_yellow_fever_vaccinated" to "חיסון נגד קדחת צהובה",
    "vaccination_description_birth_day" to "יום לידה של המחזיק",
    "vaccination_description_birth_month" to "חודש לידה של המחזיק",
    "vaccination_description_birth_year" to "שנת לידה של המחזיק",
    "vaccination_description_covid19_first_vaccination" to "נתוני חיסון ראשון - COVID-19",
    "vaccination_description_covid19_second_vaccination" to "נתוני חיסון שני - COVID-19",
    "vaccination_description_covid19_test" to "אישור שהמחזיק קיבל תוצאת בדיקה שלילית ל-COVID-19",
    "vaccination_description_covid19_vaccinated" to "אישור שהמחזיק חוסן באופן מלא נגד COVID-19",
    "vaccination_description_date_of_birth" to "תאריך לידה של המחזיק",
    "vaccination_description_facial_image" to "תמונת פנים של המחזיק",
    "vaccination_description_family_name" to "שם משפחה של המחזיק",
    "vaccination_description_family_name_initial" to "אות ראשונה של שם המשפחה של המחזיק",
    "vaccination_description_given_name" to "שם פרטי של המחזיק",
    "vaccination_description_given_name_initial" to "אות ראשונה של השם הפרטי של המחזיק",
    "vaccination_description_id_with_drivers_license_number" to "סט ייחודי של אלמנטים המזהים את המחזיק לפי מספר רישיון נהיגה",
    "vaccination_description_id_with_passport_number" to "סט ייחודי של אלמנטים המזהים את המחזיק לפי מספר דרכון",
    "vaccination_description_safe_entry_leisure" to "אישור שהמחזיק עומד בדרישות שנקבעו לכניסה בטוחה בהקשר של פנאי (מבלי לחשוף אם זה מבוסס על חיסון, החלמה או בדיקה שלילית)",
    "vaccination_description_sex" to "מין",
    "vaccination_description_yellow_fever_vaccinated" to "אישור שהמחזיק חוסן באופן מלא נגד קדחת צהובה",
    "vehicle_registration_attribute_basic_vehicle_info" to "מידע בסיסי על הרכב",
    "vehicle_registration_attribute_issue_date" to "תאריך הוצאה",
    "vehicle_registration_attribute_registration_holder" to "פרטי בעל רישוי רכב",
    "vehicle_registration_attribute_registration_info" to "פרטי רישוי רכב",
    "vehicle_registration_attribute_vin" to "מספר זיהוי רכב",
    "vehicle_registration_description_basic_vehicle_info" to "רכיב נתונים זה מכיל את מידע הרכב הבסיסי",
    "vehicle_registration_description_issue_date" to "תאריך הוצאת המסמך",
    "vehicle_registration_description_registration_holder" to "רכיב נתונים זה מזהה את בעל תעודת הרישום",
    "vehicle_registration_description_registration_info" to "רכיב נתונים זה מכיל את פרטי רישום הרכב הנפוצים, כולל רכיבי UN/EU, A ו-H.",
    "vehicle_registration_description_vin" to "מספר זיהוי רכב שהוגדר על ידי יצרן הרכב"
)
